import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SectionRuleComponent } from '../section-rule/section-rule.component';

/**
 * Read-only counterpart to EditSection. Same layout shape; consumers project InfoField
 * (PR2) or similar read-only widgets inside.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'bodyanalytics-view-section',
  standalone: true,
  imports: [SectionRuleComponent],
  templateUrl: './view-section.component.html',
  styleUrls: ['./view-section.component.scss'],
})
export class ViewSectionComponent {
  readonly label = input.required<string>();
  readonly columns = input<number>(2);
}
